'use client';

import * as React from 'react';

import { cn } from '../lib/cn';

export interface EmptyStateProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  icon?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
}

export const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ icon, title, description, action, className, ...props }, ref) => (
    <div
      ref={ref}
      role="status"
      aria-live="polite"
      className={cn(
        'border-border bg-surface flex flex-col items-center justify-center gap-2.5 rounded-2xl border border-dashed p-10 text-center',
        className,
      )}
      {...props}
    >
      {icon ? (
        <div
          aria-hidden="true"
          className="bg-primary-tint text-primary-strong flex size-11 items-center justify-center rounded-xl [&_svg]:size-5"
        >
          {icon}
        </div>
      ) : null}
      <h3 className="text-[13.5px] font-[665] tracking-[-0.015em]">{title}</h3>
      {description ? (
        <p className="text-muted-foreground max-w-sm text-[11.5px] leading-relaxed">
          {description}
        </p>
      ) : null}
      {action ? <div className="mt-1">{action}</div> : null}
    </div>
  ),
);
EmptyState.displayName = 'EmptyState';
